var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticStyle:{"height":"100%"},attrs:{"column":"","justify-center":"","align-center":""}},[_c('h1',[_vm._v(_vm._s(_vm.$t('pages.notfound.title')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('pages.notfound.text')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37e8a48c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/NotFound.vue
// module id = null
// module chunks = 